//#region Styles
import {  
    Part } from "components/styles";
//#endregion
//#region Components
import UploadFileBlock from "../../../../components/UploadFileBlock/UploadFileBlock";
//#endregion

const Part2 = ({
    changeForm, 
    fileData,
    errors 
}) => {
    //#region Functions
    const changeFileData = (newFile) => {
        changeForm({ ...newFile });
    }
    //#endregion
    return (
        <Part>
            <UploadFileBlock 
                title="Archivo personalizado"
                description={
                    <p>
                        Selecciona un archivo en formato <strong>.CSV o .xlsx (excel)</strong> que contenga las columnas del formato modelo, sigue los siguientes pasos:
                    </p>
                }
                file={fileData}
                changeForm={changeFileData}
                errors={errors}
            />
        </Part>
    );
}

export default Part2;